import React from 'react'
import { useSelector } from 'react-redux'
import { selectIsQuizPage } from '../../store/history/history.selectors'
import { selectIsVectorMap } from '../../store/map/map.selectors'
import MapEventPopin from '../genericComponents/MapEventPopin'
import UPI from '../outdoor/UPI'
import Geolocation from './Geolocation'
import MapProvider from './MapProvider'
import ContextMenu from './contextmenu/ContextMenu'
import MapDebugger from './debug/MapDebugger'
import AddressMarkersContainer from './markers/AddressMarkersContainer'
import GeolocMarker from './markers/GeolocMarker'
import Popup from './popup/Popup'
import RasterMap from './raster/RasterMap'
import MapAddressContour from './shape/MapAddressContour'
import Copyrights from './tools/Copyrights'
import GeolocButton from './tools/GeolocButton'
import Logo from './tools/Logo'
import OutdoorButton from './tools/OutdoorButton'
import Scale from './tools/Scale'
import ToggleFullScreenGeButton from './tools/ToggleFullScreenGeButton'
import ToggleFullscreenPeButton from './tools/ToggleFullscreenPeButton'
import TrafficLegend from './tools/TrafficLegend'
import ZoomButtons from './tools/ZoomButtons'
import VectorMap from './vector/VectorMap'

// webpack:BrowserOnly
const DynamicMap = ({ children }) => {
  const pageIsQuiz = useSelector(selectIsQuizPage)
  const vectorMap = useSelector(selectIsVectorMap)

  return (
    <MapProvider>
      {/*  Order matters : at least for GeolocMarker and GeolocButton */}
      <GeolocMarker />
      <GeolocButton />
      <Geolocation />
      <Scale />
      <Logo />
      <Copyrights />
      <ZoomButtons />
      {!pageIsQuiz && <OutdoorButton />}
      <TrafficLegend />
      <ToggleFullScreenGeButton />
      <ToggleFullscreenPeButton />
      <UPI />
      <Popup />
      <MapEventPopin />
      <ContextMenu />
      <MapAddressContour />
      <AddressMarkersContainer />
      <MapDebugger />
      {vectorMap ? <VectorMap /> : <RasterMap />}
      {children}
    </MapProvider>
  )
}

export default DynamicMap
